import { Avatar } from '@nautilusbio/nb-design-system/Avatar';
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Text } from '@nautilusbio/nb-design-system/Text';
import { Tooltip } from '@nautilusbio/nb-design-system/Tooltip';
import type { ReactNode } from 'react';
import React from 'react';

interface Props {
  label?: ReactNode;
  value?: string | ReactNode | null;
}

const ValueRow = ({ label, value }: Props) => (
  <Stack as="span" fullWidth gap={4} justifyContent="space-between" orientation="horizontal">
    {label && <Text as="span">{label}</Text>}
    {typeof value === 'string' && value.trim() !== '' ? (
      <Tooltip content={value} placement="top" trigger={<Avatar size="xs2">{value}</Avatar>} />
    ) : (
      value && <Tooltip content={value} placement="top" trigger={value} />
    )}
  </Stack>
);

export default ValueRow;
